"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.object.freeze");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _yunying = require("@/api/yunying");
var _constants = require("@/constants");
var _wechatManage = _interopRequireDefault(require("./components/wechat-manage"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Manage: _wechatManage.default
  },
  data: function data() {
    return {
      qrcodeRemarks: '',
      // 活码标识（中文）
      qrcodeId: '',
      // 活码ID
      qrcodeSign: '',
      // 活码标识（拼音）
      tableData: [],
      manageType: '',
      // 弹窗操作类型
      chooseData: {},
      imageUploadData: {},
      currentPage: 1,
      totalPage: 1,
      perPage: 30,
      dialogVisible: false,
      previewImage: '',
      types: _constants.FANS_TYPES_LIST,
      typesVal: [],
      wechatConstantData: {
        subject: [],
        department: []
      },
      updateTime: 0,
      expandsDefault: [],
      tableExpand: 0,
      departmentVal: [],
      subjectVal: [],
      statusVal: '',
      statusData: [{
        val: '禁用',
        type: 0
      }, {
        val: '可用',
        type: 1
      }]
    };
  },
  mounted: function mounted() {
    this.initTableData();
    if (_jsCookie.default.get('update_time') && Date.parse(new Date()) - _jsCookie.default.get('update_time') * 1000 <= 1800000) {
      this.initUpdateTime(_jsCookie.default.get('update_time'));
      return;
    } else {
      this.updateGuideDisposition();
    }
  },
  methods: {
    initUpdateTime: function initUpdateTime(timer) {
      var now = new Date(Number(timer * 1000)),
        y = now.getFullYear(),
        m = now.getMonth() + 1,
        d = now.getDate(),
        x = y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + now.toTimeString().substr(0, 8);
      this.updateTime = x;
    },
    // 微信号列表数据
    getWxComponentList: function getWxComponentList() {
      var _this = this;
      var params = {
        page: this.currentPage,
        per_page: this.perPage
      };
      if (this.qrcodeRemarks) {
        params.qrcode_remarks = this.qrcodeRemarks;
      }
      if (this.qrcodeSign) {
        params.qrcode_sign = this.qrcodeSign;
      }
      if (this.qrcodeId) {
        params.qrcode_id = this.qrcodeId;
      }
      if (this.typesVal.length) {
        params.type = this.typesVal.join(',');
      }
      if (this.departmentVal.length) {
        params.department = this.departmentVal.join(',');
      }
      if (this.subjectVal.length) {
        params.subject = this.subjectVal.join(',');
      }
      if (this.statusVal || this.statusVal === 0) {
        params.status = this.statusVal;
      }
      (0, _yunying.getWxList)(params).then(function (_ref) {
        var data = _ref.data,
          code = _ref.code;
        if (code === 200) {
          data.list.forEach(function (ele, index) {
            ele.oid = index + 1;
            ele.tps = _constants.FANS_TYPES_MAP.get(ele.type);
          });
          _this.tableData = Object.freeze(data.list);
          _this.totalPage = data.total_page;
        }
      });
    },
    // 分页
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getWxComponentList();
    },
    onSearch: function onSearch() {
      this.getWxComponentList();
    },
    onAdd: function onAdd() {
      this.chooseData = {
        status: 1,
        type: 3
      };
      this.imageUploadData = {
        img_url: ''
      };
      this.manageType = 'add';
      this.$refs.managePop.dialogVisible = true;
    },
    onModify: function onModify(val) {
      this.chooseData = val;
      this.imageUploadData = {
        img_url: val.qrcode
      };
      this.manageType = 'modify';
      this.$refs.managePop.dialogVisible = true;
    },
    onCopy: function onCopy(e) {
      this.$message({
        type: 'success',
        message: '复制成功!',
        duration: 1000
      });
    },
    onError: function onError(e) {
      this.$message.error('复制失败!');
    },
    onPreviewImage: function onPreviewImage(src) {
      this.dialogVisible = true;
      this.previewImage = src;
    },
    handleType: function handleType(val, type) {
      switch (type) {
        case 'department':
          this.departmentVal = val;
          break;
        case 'subject':
          this.subjectVal = val;
          break;
        case 'status':
          this.statusVal = val;
          break;
        default:
          this.typesVal = val;
          break;
      }
      this.getWxComponentList();
    },
    updateGuideDisposition: function updateGuideDisposition() {
      var _this2 = this;
      (0, _yunying.updateGuideDisposition)().then(function (res) {
        if (res.code === 200) {
          _this2.initUpdateTime(res.data.update_time);
          _jsCookie.default.set('update_time', res.data.update_time);
          _this2.$message({
            type: 'success',
            message: res.data.msg,
            duration: 1000
          });
        }
      });
    },
    wechatConstant: function wechatConstant() {
      var _this3 = this;
      (0, _yunying.wechatConstant)().then(function (res) {
        if (res.code === 200) {
          console.log(res);
          _this3.wechatConstantData = res.data;
        }
      });
    },
    initTableData: function () {
      var _initTableData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var flag1, flag2;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWxComponentList();
            case 2:
              flag1 = _context.sent;
              _context.next = 5;
              return this.wechatConstant();
            case 5:
              flag2 = _context.sent;
              if (flag1 && flag2 && this.tableExpand === 1) {
                this.getExpends();
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initTableData() {
        return _initTableData.apply(this, arguments);
      }
      return initTableData;
    }(),
    // 表格展开行控制
    onTableHandle: function onTableHandle(index) {
      if (index == 0) {
        this.tableExpand = 1;
      } else {
        this.tableExpand = 0;
      }
      if (this.tableExpand == 1) {
        this.getExpends();
      } else {
        this.expandsDefault = [];
      }
    },
    //设置table中的扩展项，展开的id，此处全部展开
    getExpends: function getExpends() {
      var IdDefault = this.tableData.map(function (item) {
        return item.oid;
      });
      this.expandsDefault = IdDefault;
    },
    getRowKeys: function getRowKeys(row) {
      return row.oid;
    },
    tableRowClassName: function tableRowClassName(index) {
      if (index % 2 === 0) {
        return 'second-type';
      } else {
        return 'first-type';
      }
    }
  }
};